import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import saveAs from 'file-saver'
import { baseURL } from '../../../config/baseURL'

export default function DocumentoClube() {


    const dispath = useDispatch()
    dispath({ type: 'MENU_DOC_CLUBE' })

    const [arrayDocClube, setArrayDocClube] = useState([])

    useEffect(() => {
        getDadosDocClube()
    }, [])

    async function baixarDocClube(nome_arquivo) {

        const response = await fetch(`${baseURL}doc-clube?nome_arquivo=${nome_arquivo}`, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })

        const blobFile = await response.blob()
        let fileName

        switch (blobFile.type) {
            case 'application/pdf':
                fileName = 'DocumentoCaxias.pdf'
                break;
            case 'image/jpeg':
                fileName = 'DocumentoCaxias.jpeg'
                break;
            case 'image/pjpeg':
                fileName = 'DocumentoCaxias.pjpeg'
                break;
            case 'image/png':
                fileName = 'DocumentoCaxias.png'
                break;
            default:
                fileName = 'DocumentoCaxias'
                break;
        }
        saveAs(blobFile, fileName)
    }

    async function getDadosDocClube() {

        const response = await fetch(`${baseURL}doc-clube-index-all`, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
        const respJSON = await response.json()
        setArrayDocClube(respJSON)
    }

    return (
        <div className="container">

            <div className="row  justify-content-center">
                <div className="col-md-10 py-5 px-3  rowPrincipal">

                    <div className="div" style={{ overflow: 'auto' }}>

                        <div className="col-md-7 text-justify ">
                            <h5> <strong>Documentos gerais do clube </strong> </h5>
                            <p className="text-dark"> Aqui o associado tem acesso a diversos tipos de documentos que são de interesse do associado.</p>
                        </div>

                        <table className="table table-hover text-center" style={{ overflow: 'auto', borderStyle: 'solid', borderWidth: '5px', borderColor: 'rgb(124, 3, 3)' }}>
                            <thead>
                                <tr className="text-light" style={{ backgroundColor: 'rgb(124, 3, 3)' }}>
                                    <th>Título</th>
                                    <th>Baixar</th>
                                </tr>
                            </thead>
                            <tbody className="table-secondary table-bordered">
                                {
                                    arrayDocClube.map(docClube => {
                                        return (
                                            <tr key={docClube.id} >
                                                <td className="p-auto">{docClube.titulo}</td>
                                                <td> <button onClick={() => baixarDocClube(docClube.nome_arquivo)} className="btn btn-info"> <i className="fas fa-download"></i> </button>  </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}